import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledDatabaseEntitiesQueryBar
  from 'components/organisms/Bars/DatabaseEntitiesQueryBar/DatabaseEntitiesQueryBar.styles';

const DatabaseEntitiesQueryBar = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DatabaseEntitiesQueryBar');

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledDatabaseEntitiesQueryBar ref={ref} {...innerProps} />
});

DatabaseEntitiesQueryBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DatabaseEntitiesQueryBar;
